import React from "react"
import {Route, Routes} from "react-router-dom"
import {Home} from "../../pages/Home"
import {RouteNotFound} from "../../pages/RouteNotFound"
import {ProfileRoutes} from "../ProfileRoutes"
import {RepoRoutes} from "../RepoRoutes"

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home/>}></Route>
      <Route path="/repos/*" element={<RepoRoutes/>}></Route>
      <Route path="/profile/*" element={<ProfileRoutes/>}></Route>
      <Route path="*" element={<RouteNotFound/>}></Route>
    </Routes>
  )
}
